(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('WikiRedirectController', WikiRedirectController);

    WikiRedirectController.$inject = ['$state', 'WikiSpace', '$window'];

    function WikiRedirectController($state, WikiSpace, $window) {
        WikiSpace.query({}, function (spaces) {
            var lastId = $window.localStorage.getItem('wiki.lastSpaceId');
            var target = null;

            if (lastId) {
                target = spaces.filter(function (s) {
                    return s.id === parseInt(lastId, 10);
                })[0];
            }
            if (!target) {
                target = spaces.filter(function (s) {
                    return s.nome === 'Geral';
                })[0];
            }
            if (!target && spaces.length > 0) {
                target = spaces[0];
            }
            if (target) {
                $state.go('wiki-space', {spaceId: target.id}, {location: 'replace'});
            }
        });
    }
})();
